(function () {
    'use strict';

    angular
        .module('app')
        .controller('FuelDashboardController', FuelDashboardController);

    FuelDashboardController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        '$timeout',
        '$filter',
        '$translate',
        'blockUI',
        'd3Service',
        '$uibModal',
        'FuelService',
        'SelectService',
        'POSService',
        'TerminalService',
        'NotifyService',
        'uiGmapGoogleMapApi',
        'LANGS'
    ];

    function FuelDashboardController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        $timeout,
        $filter,
        $translate,
        blockUI,
        d3Service,
        $uibModal,
        FuelService,
        SelectService,
        POSService,
        TerminalService,
        NotifyService,
        GoogleMapApi,
        LANGS
    ) {
        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.filterHelper = {};

        $scope.multilang = MultilanguageHelper();
        $scope.initLocaleStrings = initLocaleStrings;

        $scope.getFiltersList = SelectService.getLPRList;

        $scope.model = {};
        $scope.data = {
            loyaltiesList: [],
            showDisabledItems: false
        };

        $scope.dashboard = {
            selected_controller: null,
            selected_tank: null,
        };

        $scope.selectControllerDashboard = function (controller) {

            $scope.dashboard.selected_controller = null;
            $scope.dashboard.selected_tank = null;
            $scope.GraphTank.graphData = [];
            $scope.GraphTank.data = [];
            block_dashboard_controller.start();

            if (controller && $routeParams['controllerId'] !== controller.id) {
                $location.search('controllerId', controller.id);
            } else if (!controller) {
                $location.search('controllerId', null);
            }

            $scope.dashboard.selected_controller = controller;

            if ($routeParams['tankId'] && controller.tanks) {
                var tank = controller.tanks.find(function (item) {
                    return item.id === $routeParams['tankId'];
                });
                if (tank) {
                    $scope.selectTankDashboard(tank);
                }
            }
            block_dashboard_controller.stop();

        };

        $scope.selectTankDashboard = function (tank) {

            if (tank && $routeParams['tankId'] !== tank.id) {
                $location.search('tankId', tank.id);
            } else if (!tank) {
                $location.search('tankId', null);
            }

            $scope.dashboard.selected_tank = tank;
            $scope.GraphTank.graphData = [];
            $scope.GraphTank.data = [];
            $scope.buildGraphTank();
        };


        var maxGraphRangeMonths = 12;
        $scope.GraphTank = {
            openedDateFrom: false,
            openedDateTo: false,
            params: {
                date_from: moment().add(-1, 'week').startOf('day').utc().toDate(),
                date_to: moment().endOf('day').utc().toDate(),
                page: 1,
                count: 1000
            },
            minDate: moment().add(-1 * maxGraphRangeMonths, 'months').startOf('day').utc().toDate(),
            maxDate: moment().endOf('day').utc().toDate(),
            data: [],
            graphData: []
        }
        $scope.$watch('GraphTank.params.date_to', function (newValue, oldValue) {
            if (newValue) {
                $scope.GraphTank.minDate = moment(newValue).add(-1 * maxGraphRangeMonths, 'months').startOf('day').utc().toDate();
            }
        });
        $scope.$watch('GraphTank.params.date_from', function (newValue, oldValue) {
            if (newValue) {
                var maxDate = moment(newValue).add(maxGraphRangeMonths, 'months').endOf('day').utc().toDate();
                var toDay = moment().endOf('day').utc().toDate();

                if (maxDate > toDay) {
                    $scope.GraphTank.maxDate = toDay;
                } else {
                    $scope.GraphTank.maxDate = maxDate;
                }
            }
        });

        $scope.buildGraphTank = function () {
            block_graph_tank_measurements.start();
            $scope.GraphTank.data = [];
            $scope.GraphTank.graphData = [];

            var requestData = [];

            function requestTankMeasurements(paramsTankMeasurements, loyalty_id, controller_id, callback) {
                var params = angular.copy(paramsTankMeasurements);
                FuelService.getTankMeasurements(
                    loyalty_id,
                    controller_id,
                    params,
                    function (success, data) {
                        if (success) {
                            requestData = requestData.concat(data.data);
                            if (data.data.length >= paramsTankMeasurements.count) {
                                paramsTankMeasurements.page += 1;
                                requestTankMeasurements(paramsTankMeasurements, loyalty_id, controller_id, callback)
                            } else {
                                callback(requestData);
                            }
                        } else {
                            callback(requestData)
                        }
                    });

            }

            var controller = $scope.dashboard.selected_controller;
            var tank = $scope.dashboard.selected_tank;

            var paramsTankMeasurements = angular.copy($scope.GraphTank.params);
            paramsTankMeasurements.tank_id = tank.id;
            paramsTankMeasurements = dateFieldsFormat(paramsTankMeasurements, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]');

            requestTankMeasurements(paramsTankMeasurements, controller.loyalty_id, controller.id,
              function (response) {
                        var graphData = response.map(function (item) {
                            return {
                                date: moment(item.processed).toDate(),
                                water_height: item.water_height,
                                value: item.product_height,
                                product_height: item.product_height,
                                critical_high_product_alarm_height: tank.configuration.critical_high_product_alarm_height,
                                high_product_alarm_height: tank.configuration.high_product_alarm_height,
                                low_product_alarm_height: tank.configuration.low_product_alarm_height,
                                critical_low_product_alarm_height: tank.configuration.critical_low_product_alarm_height,
                                tank_filling_percentage: item.tank_filling_percentage
                            };
                        });

                        $scope.GraphTank.graphData = graphData;
                        $scope.GraphTank.data = response;
                        block_graph_tank_measurements.stop();
                }
            );
        }

        var block_dashboard_controller, block_graph_tank_measurements;
        initUiBlocks();

        function initUiBlocks() {
            block_dashboard_controller = blockUI.instances.get('dashboard-controller');
            block_graph_tank_measurements = blockUI.instances.get('graph_tank_measurements');
        }

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Initialize controller
         */
        function initControllerPage() {
            $scope.multilang.initLangs(LANGS, $rootScope.LANG);
        }

        // *********************************************************************************************
        //  SHOW PART
        // *********************************************************************************************
        /**
         * Prepare data for display page in mode 'show'
         */
        function _doShow() {
            // сначало получить список лояльностей
            loadControllers();
        }

        function loadControllers() {
            var params = {};
            FuelService.getControllerList($scope.filterHelper.id, params, function (success, data) {
                if (success) {

                    $scope.controllersList = data.map(function (item) {
                        item.allAlarms = [];
                        if (item.tanks) {
                            item.tanks.forEach(function (tank) {
                                if (tank.actual_measurements && tank.actual_measurements.alarms) {
                                    item.allAlarms = item.allAlarms.concat(tank.actual_measurements.alarms);
                                }
                            });
                        }
                        return item;
                    });

                    if ($routeParams['controllerId']) {
                        var controller = $scope.controllersList.find(function (item) {
                            return item.id === $routeParams['controllerId']
                        });
                        if (controller) {
                            $scope.selectControllerDashboard(controller);
                        }
                    }
                }
            });
        }

        $scope.onSelectFilter = function (id, item) {
            loadControllers();
        };

        $scope.onChangeShowOnlyActive = function () {
            loadControllers();
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($rootScope.ENV.filters && $rootScope.ENV.filters.categories_list && $rootScope.ENV.filters.categories_list.loyalty_id) {
                    console.log('$rootScope.ENV.filters ')
                    $scope.filterHelper.id = $rootScope.ENV.filters.categories_list.loyalty_id;
                }

                if (!$scope.filterHelper.id) {
                    console.log('if (!$scope.filterHelper.id) {')
                    $scope.filterHelper.id = getFirstActive($scope.data.loyaltiesList).id;
                }

                _doShow();
            }
        });

        $scope.$watch('filterHelper.id', function (newValue, oldValue, scope) {
            initUiBlocks();
            if (newValue && newValue !== oldValue) {

                $scope.controllersList = null;
                $scope.dashboard.selected_controller = null;
                $scope.dashboard.selected_tank = null;

                _doShow();

                $rootScope.ENV.filters.categories_list = {
                    loyalty_id: newValue
                };

                $rootScope.storeENV();
            }
        });

        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

        /**
         * Init loyalty string
         */
        function initLocaleStrings(goods_category) {
            $scope.multilang.initStrings(goods_category, ['public_title']);
        }

        /**
         * Event receive when change editing language
         */
        $scope.onChangeLanguage = function (new_lang) {
            $scope.multilang.selected(new_lang);
        };

        $scope.onShowAlertTank = function (alarms, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/pages/fuel-controllers/modals/modal.alerts-tank.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.alerts = alarms;

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    }
                }
            });
        };

        $scope.onDataExport = function (format) {
            var params = angular.copy($scope.GraphTank.params);

            params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);
            params = cleanRequestData(params);
            var file_name = $rootScope.ENV.business.code
                            + '_fuel-controller_'
                            + moment(params.date_from).format('YYYY-MM-DD_HH:mm:ss')
                            + '_' + moment(params.date_to).format('YYYY-MM-DD_HH:mm:ss')
            var export_data = angular.copy($scope.GraphTank.data);

            /**
             * Приводим объекты к единой структуре полей
             * Объекты должны быть одной структуры для корректного отображения всех столбцов в документе
             */
            export_data = export_data.map((row) => {
                return Object.assign({
                    controller_id: "",
                    processed: "",
                    product_density: "",
                    product_height: "",
                    product_mass: "",
                    product_tc_volume: "",
                    product_ullage: "",
                    product_volume: "",
                    status: "",
                    tank_filling_percentage: "",
                    tank_id: "",
                    temperature: "",
                    water_height: "",
                    water_volume: ""
                }, row);
            })
            export_data.forEach((row) => {
                /**
                 * Добавляем еденицы измерения для занчений
                 */
                Object.keys(row).forEach((key) => {
                    if (row[key] !== '') {
                        switch (key) {
                            case 'processed':
                                row[key] = moment(row[key]).format('YYYY-MM-DD HH:mm:ss')
                                break;
                            case 'product_volume':
                            case 'product_tc_volume':
                            case 'water_volume':
                            case 'product_ullage':
                                row[key] = row[key] + ' ' + $filter('translate')('L');
                                break;
                            case 'product_height':
                            case 'water_height':
                                row[key] = row[key] + ' ' + $filter('translate')('mm');
                                break;
                            case 'product_density':
                                row[key] = row[key] + ' ' + $filter('translate')('kg/m³');
                                break;
                            case 'product_mass':
                                row[key] = row[key] + ' ' + $filter('translate')('kg');
                                break;
                            case 'temperature':
                                row[key] = row[key] + ' ' + $filter('translate')('°C');
                                break;
                            case 'tank_filling_percentage':
                                row[key] = row[key] + ' %';
                                break;
                        }
                    } else {
                        // Если значение отсутствует, то заменяем на прочерк
                        row[key] = '-';
                    }
                    // Заменяем значения ключей на переведенные
                    row[$filter('translate')('Controller ' + key)] = row[key]
                    delete row[key]
                })
            })
            switch (format) {
                case 'XLSX':
                    alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [export_data]);
                    break;
                case 'XLS':
                    alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [export_data]);
                    break;
                case 'CSV':
                    alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [export_data]);
                    break;
            }
        };

        initControllerPage();
    }

})();
